import { render, staticRenderFns } from "./TaxSetting.vue?vue&type=template&id=493946c6"
import script from "./TaxSetting.vue?vue&type=script&lang=js"
export * from "./TaxSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports